<template>
  <details open="" class="feedback-details">
    <summary class="no_select" style="background: #b9d1ff">Gib uns Feedback!</summary>
    <div class="feedback-content no_select" style="text-align: left;">
      <div v-if="!feedbackSubmitted" class="feedback-box">
        <form @submit.prevent="sendFeedback" class="feedback-form">
          <textarea placeholder="Hilf uns, unseren Berater zu verbessern! Sag einfach, was dir fehlt oder unklar war.." v-model="feedback" id="feedback" required></textarea>
          <button class="feedback-btn mt-3" type="submit">Feedback senden</button>
          <p v-if="message">{{ message }}</p>
        </form>
      </div>
      <div v-if="showThankYouMessage" class="thank-you-message">
        <p>Vielen Dank für dein wertvolles Feedback! Mit deiner Hilfe können wir unseren Service stetig verbessern.</p>
      </div>
    </div>
  </details>
</template>
  
  <script>
  export default {
    data() {
      return {
        feedback: '',
        message: '',
        feedbackSubmitted: false,
        showThankYouMessage: false,
      };
    },
    methods: {
      sendFeedback() {
        $.ajax({
          url: '/wp-content/plugins/monitor-berater/get_feedback.php', 
          method: 'POST',
          data: {
            feedback: this.feedback
          },
          dataType: 'json',
          success: (response) => {
            this.message = response.message;
            if (response.status === 'success') {
              this.feedback = ''; 
              this.feedbackSubmitted = true;
              this.showThankYouMessage = true;
            }
          },
          error: (xhr, status, error) => {
            this.message = 'Es gab einen Fehler beim Senden des Feedbacks.';
          }
        });
      }
    }
  };

  </script>

  <style scoped>
.thank-you-message{
  border: none;
}

h4.feedback-headline{
  font-family: HKGroteskPro, serif !important;
}

.feedback-btn{
  background:#b9d1ff !important;
  color:#222 !important;
  border: 1px solid #222 !important;
}

.feedback-box{
  border: none;
  padding: 0px;
}

.feedback-box {
  max-width: 600px; 
  margin: auto;
  text-align: center;
}

.feedback-form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.feedback-form textarea {
  width: 100%;
  height: 150px;    
  border: 1px solid #bebcbc;
  padding: 10px;
  resize: vertical; 
  font-size: 16px;
  margin-bottom: 10px;
}

.feedback-form button {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
}

.feedback-form button:hover {
  background-color: #0056b3;
}

.feedback-details {
  border: 1px solid #ddd;

  margin-top: 20px;
  border-radius: 5px;
}
.no_select {
  cursor: default;
  user-select: none;
}


</style>